import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IGenericPayload } from "../../../../../models";
import { IMasterProfile } from "../../../../../models/resources/master/IProfile";


export interface IMasterProfileFormState {
    form: IMasterProfile;
    loading: boolean;
}

const initialState: IMasterProfileFormState = {
    form: {
        active: true,
        code: "",
        description: "",
    },
    loading: false,
};

export const masterProfileForm = createSlice({
    name: "masterProfileForm",
    initialState,
    reducers: {
        resetMasterProfileForm: () => initialState,
        setLoadingMasterProfileForm: (state, action: PayloadAction<boolean>) => {
            state.loading = action.payload;
        },
        setMasterProfileForm: (state, action: PayloadAction<IMasterProfile>) => {
            state.form = action.payload;
        },
        updateMasterProfileProperty: (state, action: PayloadAction<IGenericPayload>) => {
            state.form = {
                ...state.form,
                [action.payload.name]: action.payload.value,
            };
        },
       
    },
});

export const { resetMasterProfileForm, setLoadingMasterProfileForm, setMasterProfileForm, updateMasterProfileProperty } =
masterProfileForm.actions
export default masterProfileForm.reducer;
